import { osFetch } from './fetch'

const AUTO_DESIGN_STATUSES = [
  'NOT_STARTED',
  'QUEUED',
  'PROCESSING',
  'PROCESSING_STALE',
  'FAILED_TIMEOUT',
  'FAILED_UNKNOWN',
  'FAILED_WITH_REASON',
  'FAILED_NO_SYSTEMS',
  'COMPLETE',
  'ALL',
] as const

export const STATUSES_ACTIVE = ['QUEUED', 'PROCESSING']

export const STATUSES_FAILED = [
  'FAILED_TIMEOUT',
  'FAILED_UNKNOWN',
  'FAILED_WITH_REASON',
  'FAILED_NO_SYSTEMS',
  'PROCESSING_STALE',
]

export const STATUSES_COMPLETE = ['COMPLETE']

export async function pollAutoDesignProgress(orgId, projectId, setAutoDesignStatus) {
  /*
    return: keep polling periodically until either a) auto-design is finished b) maximum timeout is reached

    setAutoDesignProgress is optional
  */
  let delayBeforeStartPolling = 5000
  await new Promise((r) => setTimeout(r, delayBeforeStartPolling))

  let pollDelayMs = 3000
  let count = 0
  let countMax = 40
  while (count < countMax) {
    count++
    let projectData = await osFetch(`${window.API_ROOT}/api/orgs/${orgId}/projects/${projectId}/auto_design_status/`, {
      headers: window.Utils.tokenAuthHeaders({}),
      body: null,
      method: 'GET',
    }).then((response) => response.json())

    const [status, message, progress_percentage] = projectData.auto_design_status

    if (setAutoDesignStatus) {
      setAutoDesignStatus(projectData.auto_design_status)
    }

    if (STATUSES_COMPLETE.includes(status)) {
      return true
    } else if (STATUSES_ACTIVE.includes(status)) {
      // retry
      await new Promise((r) => setTimeout(r, pollDelayMs))
    } else if (STATUSES_FAILED.includes(status)) {
      throw new Error(message || 'Auto-Design Finished - Unsuccessful')
    } else {
      throw new Error('Unhandled error')
    }
  }
  throw new Error('Too many retries')
}

export const triggerAutoDesignAndAwaitProgress = async (
  orgId,
  projectId,
  triggerAutoDesign,
  setAutoDesignStatus,
  payload
) => {
  /*
    return: keep polling periodically until either a) auto-design is finished b) maximum timeout is reached

    triggerAutoDesign: we can trigger auto-design or we can just start polling for the results
  */
  if (triggerAutoDesign) {
    await osFetch(`${window.API_ROOT}/api/orgs/${orgId}/projects/${projectId}/auto_proposal/`, {
      headers: window.Utils.tokenAuthHeaders({ 'Content-Type': 'application/json' }),
      body: payload ? JSON.stringify(payload) : null,
      method: 'POST',
    }).then((response) => {
      if (response.status === 200) {
        console.log(response.json())
      } else if (response.status === 204) {
        console.log('204 ok no content')
      }
    })
  }

  return await pollAutoDesignProgress(orgId, projectId, setAutoDesignStatus)
}

export const getDataSourceFromEditor = () => {
  var mapData = window.MapHelper.activeMapInstance.toMapData()
  var dataSource: any = null

  if (mapData.mapType === 'Google3D') {
    dataSource = {
      map_data: {
        map_type: 'Google3D',
        center: [window.editor.scene.sceneOrigin4326[0], window.editor.scene.sceneOrigin4326[1]],
      },
    }
  } else if (mapData.mapType === 'Nearmap3D') {
    dataSource = {
      map_data: {
        map_type: 'Nearmap3D',
        center: [window.editor.scene.sceneOrigin4326[0], window.editor.scene.sceneOrigin4326[1]],
      },
    }
  } else if (mapData.mapType === 'None') {
    dataSource = {
      map_data: {
        map_type: 'None',
        center: [window.editor.scene.sceneOrigin4326[0], window.editor.scene.sceneOrigin4326[1]],
      },
      ground_variation_data: window.editor.scene.groundVariationData(),
    }
  }

  return dataSource
}
